import ProfileSkillListItem from './ProfileSkillListItem'

export default ProfileSkillListItem
